/** @author: Richard Scoones 14/8/2018
 *  @desc: Taken from http://ianobermiller.com/blog/2015/06/01/conditionally-load-intl-polyfill-webpack/
 */

/* eslint-disable global-require */
export default (run) => {
  // Check if polyfill required
  if (!window.Intl) {
    // Webpack parses the inside of require.ensure at build time to know if async module require is needed
    require.ensure([], () => {
      // async load intl polyfill
      require("intl")

      // Carry on
      run()
    })
  } else {
    // Polyfill wasn't needed, carry on
    run()
  }
}
/* eslint-enable global-require */
